import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { CheckCircle2, XCircle, Loader2, GraduationCap, LogIn } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function CampusVerificarEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('verificando'); // verificando | ok | error
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMensaje('Link inválido. Faltan parámetros.');
      return;
    }
    let cancelado = false;
    (async () => {
      try {
        const res = await axios.post(`${API_URL}/campus/auth/verificar-email`, { token });
        if (cancelado) return;
        setStatus('ok');
        setMensaje(res.data?.message || 'Cuenta activada con éxito.');
      } catch (err) {
        if (cancelado) return;
        setStatus('error');
        setMensaje(err.response?.data?.detail || 'No pudimos verificar tu cuenta.');
      }
    })();
    return () => { cancelado = true; };
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="text-center py-8 px-6">
          <div className="w-16 h-16 bg-violet-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <GraduationCap className="w-8 h-8 text-violet-600" />
          </div>
          {status === 'verificando' && (
            <>
              <Loader2 className="w-12 h-12 mx-auto text-violet-600 animate-spin mb-3" />
              <h1 className="text-xl font-semibold text-gray-900">Verificando tu cuenta...</h1>
            </>
          )}
          {status === 'ok' && (
            <>
              <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-500 mb-3" data-testid="verif-ok" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">¡Cuenta activada!</h1>
              <p className="text-gray-600 mb-6">{mensaje}</p>
              <Button
                className="w-full"
                onClick={() => navigate('/campus/acceso')}
                data-testid="verif-ir-login-btn"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Ingresar al Campus
              </Button>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-16 h-16 mx-auto text-red-500 mb-3" data-testid="verif-error" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">No se pudo verificar</h1>
              <p className="text-gray-600 mb-6">{mensaje}</p>
              <Button
                variant="outline"
                className="w-full"
                onClick={() => navigate('/campus/acceso')}
              >
                Volver al acceso
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
